import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Card,
  CardBody,
  Input,
  InputGroup,
  InputGroupAddon,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Bedroom from './Bedroom';
import Option from './Option';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_RMS, postAPI_Update_Room, putAPI_Update_Room_DisplayOrder } from '../../../../../constants/APIs';
import {
  gAPI_Room_ById,
  gAPI_QuestionOptionList,
  API_Ingetration_Channels,
  gAPI_Response_Amadeus,
  gAPI_Response_Mews,
  gAPI_Response_Newbook,
  gAPI_Response_SHRCRS,
  gAPI_Response_Sabre,
} from '../../../../../constants/APIs';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../components/Validation';
import CategoryTag from './CategoryTag';
const RoomForm = ({
  visible,
  toggle,
  roomId,
  propertyId,
  locale,
  categoryList,
  providerPropertyId,
}) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [roomData, setRoomData] = useState({});
  const [isViewDescription, setIsViewDescription] = useState(false);
  const [isAddBedroom, setIsAddBedroom] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [providerNames, setProviderNames] = useState([]);
  const [providerRooms, setProviderRooms] = useState([]);
  const [isProvider, setIsProvider] = useState(false);
  const [numberOfBedrooms, setNumberOfBedrooms] = useState(
    roomData.number_of_bedrooms || 0
  );
  const [categoriesData, setCategoriesData] = useState([
    ...categoryList,
    { label: 'Add New', value: 'new' },
  ]);
  const [selectedCategoryTags, setSelectedCategoryTags] = useState([]);
  const [addCategoryVisible, setAddCategoryVisible] = useState(false);
  const [editCategoryVisible, setEditCategoryVisible] = useState(false);

  const initBed = {
    bedding: [
      {
        bed_type: '',
        no_of_beds: '',
      },
    ],
  };

  const handleAddFields = () => {
    const values = [...roomData.bedArrangements];
    values.push({
      name: 'Arrangment',
      beds: [],
    });
    setRoomData({ ...roomData, bedArrangements: values });
  };
  const handleRemoveBedRooms = (index) => {
    const values = [...roomData.bedArrangements];
    values.splice(index, 1);
    setRoomData({ ...roomData, bedArrangements: values });
  };
  const handleChangeCategoryTags = (selectedOptions) => {
    if (selectedOptions.filter((i) => i.value === 'new').length === 0) {
      setSelectedCategoryTags(selectedOptions);
      const categoriesArr = selectedOptions.map((elem) => elem.value);

      setRoomData({
        ...roomData,
        searchCategoryTags: categoriesArr,
      });
    } else {
      setAddCategoryVisible(true);
    }
  };
  const handleAddCategoryTag = (data, oldtitle) => {
    let allcate = [...categoriesData];
    let selectedCate = [...selectedCategoryTags];
    var newVariable = { label: data, value: data };
    selectedCate.push(newVariable);
    allcate.push(newVariable);
    if (oldtitle !== undefined) {
      selectedCate = selectedCate
        .filter((l) => l.value !== oldtitle)
        .map((l) => l);
      allcate = allcate.filter((l) => l.value !== oldtitle).map((l) => l);
    }
    setCategoriesData(allcate);
    setSelectedCategoryTags(selectedCate);
    setRoomData({
      ...roomData,
      searchCategoryTags: selectedCate.map((l) => l.value),
    });
  };
  useEffect(() => {
    if (roomId !== '') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Room_ById}/${roomId}`,
      })
        .then((res) => {
          if (res.data.views === true) {
            setIsViewDescription(true);
          }
          AxiosAPI({
            method: 'get',
            url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Rooms`,
          })
            .then((res1) => {
              var options = [];
              try {
                res1.data.map((item) =>
                  options.push({
                    label: item.option,
                    value: item.option,
                    key: item.id,
                  })
                );
              } finally {
              }
              setTags(options);
              var selectedTags = [];
              try {
                res.data.searchTags.map((item) =>
                  selectedTags.push(
                    options.filter((cat) => cat.value === item)[0]
                  )
                );
              } finally {
              }
              setselectedTags(selectedTags);
              var selectedCategoryTags = [];
              try {
                res.data.searchCategoryTags.map((item) =>
                  selectedCategoryTags.push(
                    categoriesData.filter((cat) => cat.value === item)[0]
                  )
                );
              } finally {
              }
              setSelectedCategoryTags(selectedCategoryTags);
            })
            .catch((err) => console.log('err', err));
          let body = {
            channels: [
              'Amadues',
              'Mews',
              'Sabre',
              'SHRCRS',
              'NewbookBookingEngine',
              'RMSBookingEngine',
            ],
          };
          const callIntegrations = async () => {
            await AxiosAPI({
              method: 'post',
              url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
              data: body,
            }).then((pres) => {
              const amadeusIntegration = pres.data.filter(
                (k) =>
                  k.channel === 'Amadues' && k.properties.includes(propertyId)
              );
              const mewsIntegration = pres.data.filter(
                (k) => k.channel === 'Mews' && k.properties.includes(propertyId)
              );
              const sabreIntegration = pres.data.filter(
                (k) =>
                  k.channel === 'Sabre' && k.properties.includes(propertyId)
              );
              const shrIntegration = pres.data.filter(
                (k) =>
                  k.channel === 'SHRCRS' && k.properties.includes(propertyId)
              );
              const rmsIntegrations = pres.data.filter(
                (k) =>
                  k.channel === 'RMSBookingEngine' &&
                  k.properties.includes(propertyId)
              );
              const newbookBookingEngineIntegrations = pres.data.filter(
                (k) =>
                  k.channel === 'NewbookBookingEngine' &&
                  k.properties.includes(propertyId)
              );
              let values = [...providerNames];
              if (sabreIntegration.length > 0) {
                values.push({
                  id: 1,
                  name: 'Sabre',
                  iid: sabreIntegration[0].id,
                });
              }
              if (newbookBookingEngineIntegrations.length > 0) {
                values.push({
                  id: 1,
                  name: 'Newbook',
                  iid: newbookBookingEngineIntegrations[0].id,
                });
              }
              if (mewsIntegration.length > 0) {
                values.push({
                  id: 1,
                  name: 'Mews',
                  iid: mewsIntegration[0].id,
                });
              }
              if (shrIntegration.length > 0) {
                values.push({
                  id: 1,
                  name: 'SHRCRS',
                  iid: shrIntegration[0].id,
                });
              }
              if (rmsIntegrations.length > 0) {
                values.push({
                  id: 1,
                  name: 'RMS',
                  iid: rmsIntegrations[0].id,
                });
              }
              if (amadeusIntegration.length > 0) {
                values.push({
                  id: 1,
                  name: 'Amadeus',
                  iid: amadeusIntegration[0].id,
                });
              }
              setProviderNames(values);
              if (amadeusIntegration.length > 0) {
                if (res.data.provider !== 'None' && res.data.provider !== '') {
                  let providers = values.filter(
                    (m) => m.name == res.data.provider
                  );
                  AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Response_Amadeus}/${providers[0].iid
                      }/gethotelrooms?group_id=${getGroupID()}`,
                  })
                    .then((roomres) => {
                      var options = [];
                      console.log(roomres.data);
                      const rooms = roomres.data.guestRooms.filter(
                        (m) => m.roomStatus === 'active'
                      );
                      try {
                        rooms.map((item) =>
                          options.push({
                            id: item.id,
                            name: item.roomTypeName,
                          })
                        );
                      } finally {
                      }
                      setProviderRooms(options);
                    })
                    .catch((err) => console.log('err', err));
                  setIsProvider(true);
                }
              }
              if (mewsIntegration.length > 0) {
                if (res.data.provider !== 'None' && res.data.provider !== '') {
                  let providers = values.filter(
                    (m) => m.name == res.data.provider
                  );
                  AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Response_Mews}/${mewsIntegration[0].id
                      }/gethotelrooms?group_id=${getGroupID()}`,
                  })
                    .then((roomres) => {
                      var options = [];
                      try {
                        roomres.data.map((item) =>
                          options.push({
                            id: item.id,
                            name: item.name['en-US'],
                          })
                        );
                      } finally {
                      }
                      setProviderRooms(options);
                    })
                    .catch((err) => console.log('err', err));
                  setIsProvider(true);
                }
              }
              if (shrIntegration.length > 0) {
                if (res.data.provider !== 'None' && res.data.provider !== '') {
                  let providers = values.filter(
                    (m) => m.name == res.data.provider
                  );
                  AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Response_SHRCRS}/${shrIntegration[0].id
                      }/rooms?group_id=${getGroupID()}`,
                  })
                    .then((roomres) => {
                      var options = [];
                      try {
                        roomres.data.map((item) =>
                          options.push({
                            id: item.id,
                            name: item.name,
                          })
                        );
                      } finally {
                      }
                      setProviderRooms(options);
                    })
                    .catch((err) => console.log('err', err));
                  setIsProvider(true);
                }
              }
              if (newbookBookingEngineIntegrations.length > 0) {
                if (res.data.provider !== 'None' && res.data.provider !== '') {
                  let providers = values.filter(
                    (m) => m.name == res.data.provider
                  );
                  AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Response_Newbook}/${newbookBookingEngineIntegrations[0].id
                      }/rooms?group_id=${getGroupID()}`,
                  })
                    .then((roomres) => {
                      var options = [];
                      try {
                        roomres.data.map((item) =>
                          options.push({
                            id: item.id,
                            name: item.name,
                          })
                        );
                      } finally {
                      }
                      setProviderRooms(options);
                    })
                    .catch((err) => console.log('err', err));
                  setIsProvider(true);
                }
              }
              if (rmsIntegrations.length > 0) {
                if (
                  res.data?.categoryGroupingDetails &&
                  res.data?.categoryGroupingDetails !== null
                ) {
                  AxiosAPI({
                    method: 'get',
                    url: `${gAPI_RMS}/${rmsIntegrations[0].id
                      }/rooms-by-property?group_id=${getGroupID()}&property_id=${res.data?.categoryGroupingDetails?.propertyId
                      }`,
                  })
                    .then((roomres) => {
                      var options = [];
                      try {
                        roomres.data.guestRooms.map((item) =>
                          options.push({
                            id: item?.ProviderCode,
                            name: item?.Name,
                          })
                        );
                      } finally {
                      }
                      setProviderRooms(options);
                    })
                    .catch((err) => console.log('err', err));
                  setIsProvider(true);
                } else {
                  AxiosAPI({
                    method: 'get',
                    url: `${gAPI_RMS}/${rmsIntegrations[0].id
                      }/gethotelrooms?group_id=${getGroupID()}`,
                  })
                    .then((roomres) => {
                      var options = [];
                      try {
                        roomres.data.map((item) =>
                          options.push({
                            id: item.id,
                            name: item.roomName,
                          })
                        );
                      } finally {
                      }
                      setProviderRooms(options);
                    })
                    .catch((err) => console.log('err', err));
                  setIsProvider(true);
                }
              }
              if (sabreIntegration.length > 0) {
                if (res.data.provider !== 'None' && res.data.provider !== '') {
                  let providers = values.filter(
                    (m) => m.name == res.data.provider
                  );
                  AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Response_Sabre}/${sabreIntegration[0].id
                      }/rooms?group_id=${getGroupID()}&hotelCode=${providerPropertyId}`,
                  })
                    .then((roomres) => {
                      console.log(roomres);
                      var options = [];
                      try {
                        roomres.data.map((item) =>
                          options.push({
                            id: item.id,
                            name: item.name,
                          })
                        );
                      } finally {
                      }
                      console.log(res.data, options);
                      setProviderRooms(options);
                    })
                    .catch((err) => console.log('err', err));
                  setIsProvider(true);
                }
              }
            });
          };
          callIntegrations();
          setRoomData(res.data);
        })
        .catch((err) => console.log('err', err));
    }
  }, [roomId]);

  // useEffect(() => {

  //   //console.log(roomData.type === undefined);
  //   // if (roomData !== undefined) {
  //   //   roomData.name = roomData.nameStatements[0].statement;
  //   // }
  //   // if (roomData.type !== undefined) {
  //   //   updatedRoomData.nameStatements = roomData.nameStatements;
  //   //   setUpdatedRoomData(updatedRoomData);
  //   // }

  //   roomData.bedArrangements && roomData.bedArrangements.forEach(b => {
  //     if (b.beds.length < 2) {
  //       b.beds.push(initBed);
  //     }
  //   });
  // }, [roomData.bedArrangements, initBed]);
  const handleChangeTags = (selectedTags) => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags.map((elem) => elem.value);

    setRoomData({
      ...roomData,
      searchTags: tagsArr,
    });
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    }
  };

  const handleChange = (e) => {
    e.persist();

    if (e.target.name === 'nameStatements') {
      const index = roomData.nameStatements.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          nameStatements: [...roomData.nameStatements, newStatement],
        });
      } else {
        let newArr = [...roomData.nameStatements];
        newArr[index].statement = e.target.value;
        setRoomData({
          ...roomData,
          nameStatements: newArr,
        });
      }
    } else if (e.target.name === 'descriptionStatements') {
      const index = roomData.descriptionStatements.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          descriptionStatements: [
            ...roomData.descriptionStatements,
            newStatement,
          ],
        });
      } else {
        let newArr = [...roomData.descriptionStatements];
        newArr[index].statement = e.target.value;
        setRoomData({
          ...roomData,
          descriptionStatements: newArr,
        });
      }
    } else if (e.target.name === 'bookingUrl') {
      if (roomData.bookingUrl.length > 0) {
        const index = roomData.bookingUrl.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e.target.value,
            languageCode: locale,
          };
          setRoomData({
            ...roomData,
            bookingUrl: [...roomData.bookingUrl, newStatement],
          });
        } else {
          let newArr = [...roomData.bookingUrl];
          newArr[index].statement = e.target.value;
          setRoomData({
            ...roomData,
            bookingUrl: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          bookingUrl: [...roomData.bookingUrl, newStatement],
        });
      }
    } else if (e.target.name === 'viewsDescription') {
      if (roomData.viewsDescription.length > 0) {
        const index = roomData.viewsDescription.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e.target.value,
            languageCode: locale,
          };
          setRoomData({
            ...roomData,
            viewsDescription: [...roomData.viewsDescription, newStatement],
          });
        } else {
          let newArr = [...roomData.viewsDescription];
          newArr[index].statement = e.target.value;
          setRoomData({
            ...roomData,
            viewsDescription: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setRoomData({
          ...roomData,
          viewsDescription: [...roomData.viewsDescription, newStatement],
        });
      }
    } else {
      const value =
        tryParseInt(e.target.value, 0) === 0
          ? e.target.value
          : parseInt(e.target.value);
      if (e.target.name === 'extraBedsAllowed') {
        const extraBedAllowed = e.target.value ? true : false;
        setRoomData({ ...roomData, [e.target.name]: extraBedAllowed });
      } else if (e.target.name === 'views') {
        const views = e.target.checked ? true : false;
        if (e.target.checked) {
          setIsViewDescription(true);
        } else {
          setIsViewDescription(false);
        }
        setRoomData({
          ...roomData,
          [e.target.name]: views,
        });
      } else {
        setRoomData({ ...roomData, [e.target.name]: value });
      }
    }

    if (e.target.name === 'provider') {
      if (e.target.value !== 'None') {
        const providers = providerNames.filter((m) => m.name == e.target.value);
        if (providers.length > 0) {
          if (providers[0].name === 'Mews') {
            AxiosAPI({
              method: 'get',
              url: `${gAPI_Response_Mews}/${providers[0].iid
                }/gethotelrooms?group_id=${getGroupID()}`,
            })
              .then((roomres) => {
                var options = [];
                try {
                  roomres.data.map((item) =>
                    options.push({
                      id: item.id,
                      name: item.name,
                    })
                  );
                } finally {
                }
                setProviderRooms(options);
              })
              .catch((err) => console.log('err', err));
          } else if (providers[0].name === 'Sabre') {
            AxiosAPI({
              method: 'get',
              url: `${gAPI_Response_Sabre}/${providers[0].iid
                }/rooms?group_id=${getGroupID()}&hotelCode=${providerPropertyId}`,
            })
              .then((roomres) => {
                var options = [];
                try {
                  roomres.data.map((item) =>
                    options.push({
                      id: item.id,
                      name: item.name,
                    })
                  );
                } finally {
                }
                setProviderRooms(options);
              })
              .catch((err) => console.log('err', err));
          } else if (providers[0].name === 'SHRCRS') {
            AxiosAPI({
              method: 'get',
              url: `${gAPI_Response_SHRCRS}/${providers[0].iid
                }/rooms?group_id=${getGroupID()}`,
            })
              .then((roomres) => {
                console.log(roomres);
                var options = [];
                try {
                  roomres.data.map((item) =>
                    options.push({
                      id: item.id,
                      name: item.name,
                    })
                  );
                } finally {
                }
                setProviderRooms(options);
              })
              .catch((err) => console.log('err', err));
          } else if (providers[0].name === 'NewbookBookingEngine') {
            AxiosAPI({
              method: 'get',
              url: `${gAPI_Response_Newbook}/${providers[0].iid
                }/rooms?group_id=${getGroupID()}`,
            })
              .then((roomres) => {
                console.log(roomres);
                var options = [];
                try {
                  roomres.data.map((item) =>
                    options.push({
                      id: item.id,
                      name: item.name,
                    })
                  );
                } finally {
                }
                setProviderRooms(options);
              })
              .catch((err) => console.log('err', err));
          } else if (providers[0].name === 'RMS') {
            AxiosAPI({
              method: 'get',
              url: `${gAPI_RMS}/${providers[0].iid
                }/gethotelrooms?group_id=${getGroupID()}`,
            })
              .then((roomres) => {
                var options = [];
                try {
                  roomres.data.map((item) =>
                    options.push({
                      id: item.id,
                      name: item.roomName,
                    })
                  );
                } finally {
                }
                setProviderRooms(options);
              })
              .catch((err) => console.log('err', err));
          } else {
            AxiosAPI({
              method: 'get',
              url: `${gAPI_Response_Amadeus}/${providers[0].iid
                }/gethotelrooms?group_id=${getGroupID()}`,
            })
              .then((res) => {
                var options = [];
                console.log(res.data);
                const rooms = res.data.guestRooms.filter(
                  (m) => m.roomStatus === 'active'
                );
                try {
                  rooms.map((item) =>
                    options.push({
                      id: item.id,
                      name: item.roomTypeName,
                    })
                  );
                } finally {
                }
                setProviderRooms(options);
              })
              .catch((err) => console.log('err', err));
          }
        }
        setIsProvider(true);
      } else {
        setIsProvider(false);
      }
    }
  };

  const updateRoom = async () => {
    //  console.log("ROOM DATA:: ", roomData);
    let data = {
      ...roomData,
      updater: 'updater',
    };
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Update_Room}/${roomId}`,
      data: data,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  const updateDisplayOrder = async () => {
    try {
      let data = {
        displayOrder: roomData.displayOrder,
      };
      const res = await AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Room_DisplayOrder}/${roomId}/display-order`,
        data: data,
      });

      console.log('Response:', res.data);
      window.location.reload();

    } catch (err) {
      console.log('err', err?.response || err);
    }
  };

  const tryParseInt = (str, defaultValue) => {
    var retValue = defaultValue;
    if (str !== null) {
      if (str.length > 0) {
        if (!isNaN(str)) {
          retValue = parseInt(str);
        }
      }
    }
    return retValue;
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}>
          {/* <IntlMessages id="modal.modal-title" /> */}
        </ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Card>
                <CardBody>
                  <CardTitle>
                    {/* <IntlMessages id="forms.grid" /> */}
                  </CardTitle>
                  {roomData.type !== undefined ? (
                    <Form>
                      {/* <pre>{JSON.stringify(roomData, null, 2)}</pre> */}
                      <FormGroup row>
                        <Colxx sm={6}>
                          <FormGroup>
                            <Label for="type">
                              {/* <IntlMessages id="forms.email" /> */}
                              <IntlMessages id="dashboards.room-type" />
                            </Label>
                            <Input
                              type="select"
                              onChange={handleChange}
                              name="type"
                              id="type"
                              disabled={
                                roomData.provider === 'RMS' ||
                                  roomData.provider === 'Sabre' ||
                                  roomData.provider === 'Amadeus'
                                  ? true
                                  : false
                              }
                              defaultValue={roomData.type}
                            >
                              <option value="">Choose Room Type</option>
                              <option value="Accommodation">
                                Accommodation
                              </option>
                              <option value="Apartment">Apartment</option>
                              <option value="Bed in Dormitory">
                                Bed in Dormitory
                              </option>
                              <option value="Bungalow">Bungalow</option>
                              <option value="Cabin">Cabin</option>
                              <option value="Site">Site</option>
                              <option value="Caravan Site">Caravan Site</option>
                              <option value="Chalet">Chalet</option>
                              <option value="Dormitory room">
                                Dormitory Room
                              </option>
                              <option value="Double">Double</option>
                              <option value="Family">Family</option>
                              <option value="Family Unit">Family Unit</option>
                              <option value="Holiday home">Holiday Home</option>
                              <option value="House">House</option>
                              <option value="Mobile home">Mobile Home</option>
                              <option value="Motel Unit">Motel Unit</option>
                              <option value="Non Powered Site">
                                Non Powered Site
                              </option>
                              <option value="Other Unit (homesstead, villa etc)">
                                Other Unit (homesstead, villa etc)
                              </option>
                              <option value="Powered Site">Powered Site</option>
                              <option value="Quadruple">Quadruple</option>
                              <option value="Self Contained Unit">
                                Self Contained Unit
                              </option>
                              <option value="Single">Single</option>
                              <option value="Studio">Studio</option>
                              <option value="Suite">Suite</option>
                              <option value="Tent">Tent</option>
                              <option value="Tent Site (tent, yurt, teepee etc)">
                                Tent Site (tent, yurt, teepee etc)
                              </option>
                              <option value="Triple">Triple</option>
                              <option value="Twin">Twin</option>
                              <option value="Villa">Villa</option>
                            </Input>
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={6}>
                          <FormGroup>
                            <Label for="standardCapacity">
                              {/* <IntlMessages id="forms.password" /> */}
                              <IntlMessages id="dashboards.how-many-guests" />
                            </Label>
                            <Input
                              type="number"
                              name="standardCapacity"
                              id="standardCapacity"
                              min={0}
                              disabled={
                                roomData.provider === 'RMS' ||
                                  roomData.provider === 'Sabre' ||
                                  roomData.provider === 'Amadeus'
                                  ? true
                                  : false
                              }
                              onChange={handleChange}
                              defaultValue={roomData.standardCapacity}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx sm={6}>
                          <FormGroup>
                            <Label for="nameStatements">
                              {/* <IntlMessages id="forms.password" /> */}
                              <IntlMessages id="dashboards.room-name" />
                            </Label>
                            <Input
                              type="text"
                              name="nameStatements"
                              id="nameStatements"
                              defaultValue={getLocalStatement(
                                roomData.nameStatements
                              )}
                              onChange={handleChange}
                              disabled={
                                roomData.provider === 'Newbook' ||
                                  roomData.provider === 'Sabre' ||
                                  roomData.provider === 'RMS' ||
                                  roomData.provider === 'Amadeus'
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx sm={6}>
                          <FormGroup>
                            <Label for="numberRoomsInProperty">
                              {/* <IntlMessages id="forms.password" /> */}
                              <IntlMessages id="dashboards.number-of-rooms-this-type" />
                            </Label>
                            <Input
                              type="number"
                              name="numberRoomsInProperty"
                              id="numberRoomsInProperty"
                              min={0}
                              disabled={
                                roomData.provider === 'Sabre' ||
                                  roomData.provider === 'RMS' ||
                                  roomData.provider === 'Amadeus'
                                  ? true
                                  : false
                              }
                              defaultValue={roomData.numberRoomsInProperty}
                              onChange={handleChange}
                            //   placeholder={messages['forms.password']}
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={12}>
                          <FormGroup>
                            <Label for="descriptionStatement">
                              <IntlMessages id="pages.description" />
                            </Label>
                            <Input
                              type="textarea"
                              name="descriptionStatements"
                              disabled={
                                roomData.provider === 'Sabre' ||
                                  roomData.provider === 'Newbook' ||
                                  roomData.provider === 'RMS' ||
                                  roomData.provider === 'Amadeus'
                                  ? true
                                  : false
                              }
                              id="descriptionStatements"
                              defaultValue={getLocalStatement(
                                roomData.descriptionStatements
                              )}
                              onChange={handleChange}
                              style={{
                                height: `${roomData.provider === 'Sabre' ? 200 : 80}px`,
                              }}
                            //   placeholder={messages['forms.password']}
                            />
                          </FormGroup>
                        </Colxx>
                        {roomData.provider !== 'Sabre' && (
                          <Fragment>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label for="numberBedrooms">
                                  {/* <IntlMessages id="forms.password" /> */}
                                  <IntlMessages id="dashboards.number-of-bedrooms" />
                                </Label>
                                <Input
                                  type="number"
                                  name="numberBedrooms"
                                  id="numberBedrooms"
                                  min={0}
                                  defaultValue={roomData.numberBedrooms}
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                //   placeholder={messages['forms.password']}
                                />
                              </FormGroup>
                            </Colxx>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label for="numberOfLivingrooms">
                                  {/* <IntlMessages id="forms.password" /> */}
                                  <IntlMessages id="dashboards.number-of-livingrooms" />
                                </Label>
                                <Input
                                  type="number"
                                  name="numberLivingRooms"
                                  id="numberLivingRooms"
                                  min={0}
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                  defaultValue={roomData.numberLivingRooms}
                                  onChange={handleChange}
                                //   placeholder={messages['forms.password']}
                                />
                              </FormGroup>
                            </Colxx>

                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="dashboards.minimum-adults" />
                                  {/* <IntlMessages id="forms.state" /> */}
                                </Label>
                                <Input
                                  type="number"
                                  name="minimumAdults"
                                  id="minimumAdults"
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                  defaultValue={roomData.minimumAdults}
                                  onChange={handleChange}
                                ></Input>
                              </FormGroup>
                            </Colxx>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="dashboards.maximum-adults" />
                                  {/* <IntlMessages id="forms.state" /> */}
                                </Label>
                                <Input
                                  type="number"
                                  name="maximumAdults"
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                  defaultValue={roomData.maximumAdults}
                                  onChange={handleChange}
                                ></Input>
                              </FormGroup>
                            </Colxx>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="dashboards.maximum-children" />
                                  {/* <IntlMessages id="forms.state" /> */}
                                </Label>
                                <Input
                                  type="number"
                                  name="maximumChildren"
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                  defaultValue={roomData.maximumChildren}
                                  onChange={handleChange}
                                ></Input>
                              </FormGroup>
                            </Colxx>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="dashboards.maximum-infants" />
                                  {/* <IntlMessages id="forms.state" /> */}
                                </Label>
                                <Input
                                  type="number"
                                  name="maximumInfants"
                                  id="maximumInfants"
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                  defaultValue={roomData.maximumInfants}
                                  onChange={handleChange}
                                ></Input>
                              </FormGroup>
                            </Colxx>
                          </Fragment>
                        )}
                        <Colxx sm={3}>
                          <FormGroup>
                            <Label for="floorSize">
                              <IntlMessages id="dashboards.numberofBeds" />
                            </Label>
                            <InputGroup>
                              <Input
                                type="number"
                                name="numberBeds"
                                id="numberBeds"
                                disabled={
                                  roomData.provider === 'Sabre' ||
                                    roomData.provider === 'Amadeus'
                                    ? true
                                    : false
                                }
                                defaultValue={roomData.numberBeds}
                                // defaultValue={roomData.floorSize && roomData.floorSize.split(':')[0]}
                                onChange={handleChange}
                              />
                              <InputGroupAddon addonType="append"></InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                        </Colxx>
                        <Colxx sm={3}>
                          <FormGroup className="m-4">
                            <Label>
                              <Input
                                type="checkbox"
                                name="extraBedsAllowed"
                                id="extraBedsAllowed"
                                onChange={handleChange}
                                disabled={
                                  roomData.provider === 'Sabre' ||
                                    roomData.provider === 'Amadeus'
                                    ? true
                                    : false
                                }
                                defaultValue={roomData.extraBedsAllowed}
                              />
                              <IntlMessages id="dashboards.extra-beds-allowed" />
                            </Label>
                          </FormGroup>
                        </Colxx>
                        {roomData.provider !== 'Sabre' && (
                          <Fragment>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label for="floorSize">
                                  <IntlMessages id="dashboards.room-size" />
                                </Label>
                                <InputGroup>
                                  <Input
                                    type="number"
                                    name="floorSize"
                                    id="floorSize"
                                    disabled={
                                      roomData.provider === 'Sabre' ||
                                        roomData.provider === 'Amadeus'
                                        ? true
                                        : false
                                    }
                                    defaultValue={roomData.floorSize}
                                    // defaultValue={roomData.floorSize && roomData.floorSize.split(':')[0]}
                                    onChange={handleChange}
                                  />
                                  <InputGroupAddon addonType="append"></InputGroupAddon>
                                </InputGroup>
                              </FormGroup>
                            </Colxx>
                          </Fragment>
                        )}
                        {roomData.provider !== 'Sabre' && (
                          <Fragment>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="dashboards.booking-engine-code" />
                                  {/* <IntlMessages id="forms.state" /> */}
                                </Label>
                                <Input
                                  type="text"
                                  name="bookingEngineCode"
                                  id="bookingEngineCode"
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                  defaultValue={roomData.bookingEngineCode}
                                  onChange={handleChange}
                                />
                              </FormGroup>
                            </Colxx>
                          </Fragment>
                        )}

                        {roomData.provider !== 'Sabre' && (
                          <Fragment>
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="dashboards.balcony-area" />
                                  {/* <IntlMessages id="forms.state" /> */}
                                </Label>
                                <Input
                                  type="number"
                                  name="balconyArea"
                                  defaultValue={roomData.balconyArea}
                                  onChange={handleChange}
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                ></Input>
                              </FormGroup>
                            </Colxx>

                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="dashboards.unit" />
                                </Label>
                                <Input
                                  type="select"
                                  onChange={handleChange}
                                  defaultValue={roomData.measurementUnit}
                                  name="measurementUnit"
                                  id="measurementUnit"
                                  disabled={
                                    roomData.provider === 'Sabre' ||
                                      roomData.provider === 'Amadeus'
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="Sqmt">square meters</option>
                                  <option value="Sqft">square feet</option>
                                </Input>
                              </FormGroup>
                            </Colxx>
                          </Fragment>
                        )}
                        <Colxx sm={3}>
                          <FormGroup>
                            <Label for="displayOrder">
                              {/* <IntlMessages id="forms.password" /> */}
                              <IntlMessages id="dashboards.displayOrder" />
                            </Label>
                            <div className="d-flex">
                              <Input
                                type="number"
                                name="displayOrder"
                                id="displayOrder"
                                min={0}
                                defaultValue={roomData.displayOrder}
                                onChange={handleChange}
                              />
                              {(roomData.provider === 'Sabre' ||
                                roomData.provider === 'Amadeus') && (
                                  <button type="button"
                                    style={{
                                      border: '1px solid #d7d7d7',
                                      backgroundColor: '#e0d9d9',
                                      paddingLeft: '10px',
                                      paddingRight: '10px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={updateDisplayOrder}
                                    title="Save Display Order"
                                  >
                                    Save
                                  </button>

                                )}
                            </div>
                          </FormGroup>
                        </Colxx>
                        <Colxx sm={3}>
                          <FormGroup className="m-4">
                            <Label>
                              <Input
                                type="checkbox"
                                name="views"
                                id="views"
                                onChange={handleChange}
                                checked={roomData.views}
                                disabled={
                                  roomData.provider === 'Sabre' ||
                                    roomData.provider === 'Amadeus'
                                    ? true
                                    : false
                                }
                              />{' '}
                              <IntlMessages id="dashboards.views" />
                            </Label>
                          </FormGroup>
                        </Colxx>
                        {isViewDescription && (
                          <Colxx sm={9}>
                            <FormGroup>
                              <Label>View Description</Label>
                              <Input
                                defaultValue={getLocalStatement(
                                  roomData.viewsDescription
                                )}
                                name="viewsDescription"
                                id="viewsDescription"
                                maxLength={30}
                                onChange={handleChange}
                                disabled={
                                  roomData.provider === 'Sabre' ||
                                    roomData.provider === 'Amadeus'
                                    ? true
                                    : false
                                }
                              />
                            </FormGroup>
                          </Colxx>
                        )}
                        <Colxx sm={12}>
                          <FormGroup>
                            <Label for="bookingUrl">
                              <IntlMessages id="dashboards.bookingURL" />
                            </Label>
                            <Input
                              type="text"
                              name="bookingUrl"
                              id="bookingUrl"
                              defaultValue={getLocalStatement(
                                roomData.bookingUrl
                              )}
                              onChange={handleChange}
                              disabled={
                                roomData.provider === 'Sabre' ||
                                  roomData.provider === 'Amadeus'
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Colxx>
                        {roomData.provider !== 'Sabre' &&
                          roomData.provider !== 'Amadeus' && (
                            <Fragment>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label for="bookingUrl">
                                    <IntlMessages id="dashboards.searchTags" />
                                  </Label>
                                  <Select
                                    components={{ Input: CustomSelectInput }}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isMulti={true}
                                    name="form-field-name"
                                    value={selectedTags}
                                    onChange={handleChangeTags}
                                    options={tags}
                                    disabled={
                                      roomData.provider === 'Sabre' ||
                                        roomData.provider === 'Amadeus'
                                        ? true
                                        : false
                                    }
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx sm={12}>
                                <FormGroup>
                                  <Label for="bookingUrl">
                                    <IntlMessages id="dashboards.searchCategoryTags" />
                                  </Label>
                                  <Select
                                    components={{ Input: CustomSelectInput }}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isMulti={true}
                                    name="form-field-name"
                                    value={selectedCategoryTags}
                                    onChange={handleChangeCategoryTags}
                                    options={categoriesData}
                                    disabled={
                                      roomData.provider === 'Sabre' ||
                                        roomData.provider === 'Amadeus'
                                        ? true
                                        : false
                                    }
                                  />
                                  {categoriesData.length > 1 && (
                                    <div className="d-flex justify-content-end mt-2">
                                      <Button
                                        outline
                                        color="primary"
                                        size="xs"
                                        onClick={() => {
                                          setEditCategoryVisible(
                                            !editCategoryVisible
                                          );
                                          setAddCategoryVisible(true);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faEdit} />
                                        {''}
                                        <IntlMessages id="survey.edit" />{' '}
                                        <IntlMessages id="survey.category" />
                                      </Button>
                                    </div>
                                  )}
                                </FormGroup>
                              </Colxx>
                            </Fragment>
                          )}
                        {providerNames.length > 0 && (
                          <Colxx sm={6}>
                            <FormGroup>
                              <Label for="provider">
                                <IntlMessages id="dashboards.provider" />
                              </Label>
                              <Input
                                type="select"
                                name="provider"
                                disabled={
                                  roomData.provider === 'Newbook' ||
                                    roomData.provider === 'Sabre' ||
                                    roomData.provider === 'RMS' ||
                                    roomData.provider === 'Amadeus'
                                    ? true
                                    : false
                                }
                                onChange={handleChange}
                                defaultValue={roomData.provider}
                              >
                                <option value="0">None</option>
                                {providerNames.map((name) => {
                                  return (
                                    <option value={name.name} key="i">
                                      {name.name === 'Sabre'
                                        ? 'SynXis'
                                        : name.name}
                                    </option>
                                  );
                                })}
                              </Input>
                            </FormGroup>
                          </Colxx>
                        )}
                        {isProvider && (
                          <Colxx sm={6}>
                            <FormGroup>
                              <Label for="roomcode">Room</Label>
                              <Input
                                type="select"
                                name="providerRoomCode"
                                onChange={handleChange}
                                disabled={
                                  roomData.provider === 'Newbook' ||
                                    roomData.provider === 'Sabre' ||
                                    roomData.provider === 'RMS' ||
                                    roomData.provider === 'Amadeus'
                                    ? true
                                    : false
                                }
                                value={roomData?.providerRoomCode}
                              >
                                <option value="">None</option>
                                {providerRooms.map((name) => {
                                  return (
                                    <option value={name.id} key={name.id}>
                                      {name.name} - {name.id}
                                    </option>
                                  );
                                })}
                              </Input>
                            </FormGroup>
                          </Colxx>
                        )}
                        {roomData?.categoryGroupingDetails &&
                          roomData.provider === 'RMS' && (
                            <Fragment>
                              {roomData?.categoryGroupingDetails?.id &&
                                roomData?.categoryGroupingDetails?.id !=
                                '0' && (
                                  <Fragment>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label for="category_group_id">
                                          {/* <IntlMessages id="dashboards.bookingURL" /> */}
                                          Category Group Id
                                        </Label>
                                        <Input
                                          type="text"
                                          name="categoryGroupingDetailsId"
                                          id="categoryGroupingDetailsId"
                                          defaultValue={
                                            roomData?.categoryGroupingDetails
                                              ?.id
                                          }
                                          disabled={true}
                                        />
                                      </FormGroup>
                                    </Colxx>
                                  </Fragment>
                                )}
                              {roomData?.categoryGroupingDetails?.name && (
                                <Fragment>
                                  <Colxx sm={6}>
                                    <FormGroup>
                                      <Label for="category_group_name">
                                        Category Group Name
                                      </Label>
                                      <Input
                                        type="text"
                                        name="categoryGroupingDetailsName"
                                        id="categoryGroupingDetailsName"
                                        defaultValue={
                                          roomData?.categoryGroupingDetails
                                            ?.name
                                        }
                                        disabled={true}
                                      />
                                    </FormGroup>
                                  </Colxx>
                                </Fragment>
                              )}
                              {roomData?.categoryGroupingDetails?.propertyId &&
                                roomData?.categoryGroupingDetails
                                  ?.propertyId !== '' && (
                                  <Fragment>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label for="category_group_name">
                                          Property
                                        </Label>
                                        <Input
                                          type="text"
                                          name="categoryGroupingDetailsProperty"
                                          id="categoryGroupingDetailsProperty"
                                          defaultValue={
                                            roomData?.categoryGroupingDetails
                                              ?.propertyName +
                                            ' - ' +
                                            roomData?.categoryGroupingDetails
                                              ?.propertyId +
                                            ''
                                          }
                                          disabled={true}
                                        />
                                      </FormGroup>
                                    </Colxx>
                                  </Fragment>
                                )}
                            </Fragment>
                          )}
                      </FormGroup>
                    </Form>
                  ) : null}
                </CardBody>
              </Card>
            </Colxx>
          </Row>
          {roomData.provider !== 'Sabre' &&
            roomData.provider !== 'Amadeus' &&
            roomData.bedArrangements !== undefined &&
            roomData.bedArrangements.map((oneBedroom, index) => {
              return (
                <Fragment key={index}>
                  <Bedroom
                    oneBedroom={oneBedroom}
                    isAddBedroom={false}
                    roomData={roomData}
                    setRoomData={setRoomData}
                    handleRemoveBedRooms={handleRemoveBedRooms}
                    roomindex={index}
                  />
                </Fragment>
              );
            })}
          {/* {isAddBedroom && (
            <Bedroom
              oneBedroom={initBed}
              isAddBedroom={isAddBedroom}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          )} */}
          {roomData.provider !== 'Sabre' && roomData.provider !== 'Amadeus' && (
            <Row>
              <Colxx xxs="12">
                <Button
                  color="primary"
                  outline
                  size="xs"
                  onClick={handleAddFields}
                  style={{ width: '100%', borderRadius: '6px' }}
                >
                  + <IntlMessages id="dashboards.addBedroom" />
                </Button>
              </Colxx>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          {roomData.provider !== 'Sabre' && roomData.provider !== 'Amadeus' && (
            <Button color="primary" onClick={updateRoom}>
              <IntlMessages id="dashboards.update" />
            </Button>
          )}
          <Button color="secondary" onClick={toggle}>
            <IntlMessages id="pages.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
      {addCategoryVisible && (
        <CategoryTag
          visible={addCategoryVisible}
          toggle={() => setAddCategoryVisible(!addCategoryVisible)}
          handleAddCategoryTag={handleAddCategoryTag}
          categoryList={categoriesData}
          isEdit={editCategoryVisible}
        ></CategoryTag>
      )}
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { propertyId, providerPropertyId } = settings;
  return {
    propertyId,
    providerPropertyId: providerPropertyId,
  };
};
export default injectIntl(connect(mapStateToProps)(RoomForm));
